import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { IModalComponentProps } from '@context/modal_context';

const DeletePhoneModal: FC<IModalComponentProps<{ phone_code: string; phone_number: string }>> = ({
    modalData
}) => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'delete_phone'
    });

    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" className={styles.title}>
                {t('title')}
            </Typography>
            <Typography variant="body2" className={styles.description}>
                {t('sure')}{' '}
                <b>
                    {modalData.phone_code} {modalData.phone_number}
                </b>
                ?
            </Typography>
        </div>
    );
};

export default DeletePhoneModal;
